export default __webpack_public_path__ + "static/media/pattern.2be3aa0c.png";